export const CHAT_PAGE_SIZE = 20

export const reducerSetPagination = ({ pageSize, ...state }) => ({
  ...state,
  pageSize: pageSize + CHAT_PAGE_SIZE,
})
